import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import messages from './messages.tsx';
import { compareStatistics } from './utils.tsx';

type TrendColorScheme = 'UP_IS_GOOD' | 'UP_IS_BAD';

type Props = {
	current: number;
	median: number;
	colorScheme: TrendColorScheme;
};

type LozengeProps = {
	message: MessageDescriptor;
	appearance: 'moved' | 'success';
};
export const getLozengeProps = (
	current: number,
	median: number,
	colorScheme: TrendColorScheme,
): LozengeProps => {
	const trend = compareStatistics(current, median);
	switch (trend) {
		case 'over':
			return {
				message: messages.over,
				appearance: colorScheme === 'UP_IS_GOOD' ? 'success' : 'moved',
			};
		case 'under':
			return {
				message: messages.under,
				appearance: colorScheme === 'UP_IS_GOOD' ? 'moved' : 'success',
			};
		case 'equal':
			return {
				message: messages.equal,
				appearance: 'success',
			};
		default:
			// prettier-ignore
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(trend as never);
			throw new Error('Unknown trend is given to getLozengeProps');
	}
};

export const TrendLozenge = ({ current, median, colorScheme }: Props) => {
	const { formatMessage } = useIntl();
	const lozengeProps = getLozengeProps(current, median, colorScheme);

	return (
		<Lozenge appearance={lozengeProps.appearance}>{formatMessage(lozengeProps.message)}</Lozenge>
	);
};
